var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_19970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 3.79086 3.79086 2 6 2H29V11H11V29H2V6Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 29H11V38H6C3.79086 38 2 36.2091 2 34V29Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 2H34C36.2091 2 38 3.79086 38 6V11H29V2Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 29H38L29 38V29Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 29,
    width: 18,
    height: 9,
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 11,
    width: 9,
    height: 18,
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4131 24.9078C13.705 24.442 13.215 23.762 12.9473 22.8625L14.5909 22.2033C14.74 22.7568 15.001 23.1854 15.3728 23.4897C15.7418 23.794 16.1918 23.9442 16.7177 23.9442C17.2555 23.9442 17.7173 23.785 18.1031 23.4667C18.4896 23.1489 18.6836 22.7427 18.6836 22.2517C18.6836 21.7494 18.48 21.3387 18.0728 21.0209C17.665 20.7025 17.1536 20.5434 16.5428 20.5434H15.5927V18.9594H16.4455C16.9714 18.9594 17.4141 18.8215 17.7741 18.5448C18.1341 18.268 18.3141 17.89 18.3141 17.4085C18.3141 16.9794 18.1532 16.6379 17.8309 16.382C17.5091 16.126 17.1013 15.9972 16.6063 15.9972C16.1231 15.9972 15.7401 16.1215 15.4555 16.373C15.1729 16.6228 14.9593 16.941 14.835 17.2972L13.2077 16.6379C13.4231 16.0434 13.8191 15.5174 14.3991 15.0629C14.9796 14.609 15.721 14.3812 16.621 14.3812C17.2864 14.3812 17.8855 14.5055 18.4159 14.7569C18.9463 15.0084 19.3631 15.356 19.6646 15.7987C19.965 16.2436 20.1146 16.742 20.1146 17.2949C20.1146 17.8597 19.974 18.3372 19.695 18.7293C19.4294 19.1086 19.0758 19.4178 18.6645 19.6304V19.7249C19.1876 19.9337 19.6444 20.2803 19.9864 20.7279C20.3295 21.1779 20.5028 21.7145 20.5028 22.3417C20.5028 22.9689 20.3396 23.5285 20.0123 24.0202C19.6855 24.5112 19.2332 24.8982 18.66 25.1795C18.0846 25.4607 17.4377 25.6042 16.72 25.6042C15.8891 25.6064 15.1213 25.3735 14.4137 24.9078H14.4131ZM24.51 16.9675L22.705 18.2382L21.8027 16.9051L25.0405 14.6326H26.2813V25.355H24.5095V16.9681L24.51 16.9675Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_19970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendar);
export default __webpack_public_path__ + "static/media/google-calendar.737445d6e128c60a922b08b727a2c25f.svg";
export { ForwardRef as ReactComponent };